import { ReactElement } from 'react';
import { Link } from 'react-router-dom';

type WriteRulesNoticeProps = {
  /**
   * The operation the list's rules check this endpoint as. Restores and
   * partial-data writes are checked as updates
   */
  operation: 'create' | 'update' | 'delete';
};

const operationNames = {
  create: 'create',
  update: 'update',
  delete: 'delete',
};

/**
 * What a list's write rules can do to this request
 *
 * Every endpoint that writes an item says this, so it's in one place to keep
 * the wording consistent
 */
export function WriteRulesNotice({
  operation,
}: WriteRulesNoticeProps): ReactElement {
  return (
    <p>
      On a list with <Link to="/docs/write-rules">write rules</Link>, this is
      checked against the rules for <code>{operationNames[operation]}</code>{' '}
      before anything is written. A write nothing authorises is refused with{' '}
      <code>403</code>, one that fails a check with <code>400</code> and the
      rule's message, and one whose item changed while it was being written with{' '}
      <code>409</code>.
    </p>
  );
}
